import PropTypes from 'prop-types';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHtmlLang } from 'core/hooks/useHtmlLang';
import i18n from './i18n';

/*import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/dist/locale-data/en";
import "@formatjs/intl-relativetimeformat/dist/locale-data/de";
import "@formatjs/intl-relativetimeformat/dist/locale-data/es";
import "@formatjs/intl-relativetimeformat/dist/locale-data/fr";
import "@formatjs/intl-relativetimeformat/dist/locale-data/ja";
import "@formatjs/intl-relativetimeformat/dist/locale-data/zh";*/

export default function I18nProvider({ children }) {
  // Defensive selector with default fallback to prevent null reference errors
  const locale = useSelector(({ i18n = {} }) => i18n?.lang || 'es');
  i18n.changeLanguage(locale);
  useHtmlLang();
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

I18nProvider.propTypes = {
  children: PropTypes.node,
};
